import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { playAudio } from "../../utils/btnAudio";
import { CButton } from "../CommonComponents";

export default function CancelSubscriptionModal({ isOpen, closeModal, close }) {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={close}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Remove Subscription
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-md text-gray-600">
                      Are you sure you want to Cancel your Cook-E AI membership?
                    </p>
                  </div>

                  <div className="mt-4">
                    <CButton
                      variant='skin'
                      type="button"
                      className="inline-flex text-white justify-center rounded-md border border-transparent !bg-orange-50 px-4 py-2 text-sm font-medium  hover:bg-orange-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={() => {
                        playAudio();
                        closeModal();
                      }}
                    >
                      Return to Page
                    </CButton>
                    <button
                      type="button"
                      className="inline-flex text-orange-700 justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium  focus-visible:ring-2 "
                      onClick={() => {
                        playAudio();
                        close(); //cancel function
                      }}
                    >
                      Cancel Membership
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
